// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"066d7f60","239":"46fa55cb","453":"3154de31","455":"21603a8b"}[chunkId] + ".chunk.js";
};